import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {useGetTransactionList} from '../../context/useQuery'
import {useTransactionList} from '../../hook'
import {DebounceInput} from 'react-debounce-input'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import FilterDrawer from './FilterDrawer'

const TransactionItemList = ({disclaimer}: {disclaimer?: boolean}) => {
  const intl = useIntl()

  const {isLoading} = useGetTransactionList()
  const {listFilter, listFilterSet, list, listSet} = useTransactionList()

  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('0')

  const paging = list?.paging || {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 1,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'OrderId',
      dataIndex: 'orderId',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.ORDER_ID'}),
    },
    {
      key: 'Date',
      dataIndex: 'date',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.DATE_TIME'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'Type',
      dataIndex: 'type',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.TYPE'}),
      render: (text: string) => {
        let color = 'text-success'

        switch (text) {
          case 'Cancel':
            color = 'text-error'
            break
          case 'Refund':
            color = 'text-refund'
            break
          case 'Sale':
            color = 'text-success'
            break
          case 'SignUp':
            color = 'text-signup'
            break
          case 'Birthday':
            color = 'text-info'
            break
          default:
            color = 'text-success'
            break
        }

        return <span className={color}>{text}</span>
      },
    },
    {
      key: 'Amount',
      dataIndex: 'paidAmount',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.AMOUNT'}),
      customMonetize: true,
    },
    {
      key: 'Channel',
      dataIndex: 'channel',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.CHANNEL'}),
    },
    {
      key: 'MemberName',
      dataIndex: 'memberName',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.MEMBER_NAME'}),
      render: (text: string) => (
        <>{text && text !== '' && text !== ' ' ? text : 'Fast Onboarded'}</>
      ),
    },
    {
      key: 'StoreId',
      dataIndex: 'storeNo',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.STORE_ID'}),
    },
    {
      key: 'detailURL',
      dataIndex: 'transactionId',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.ACTION'}),
      render: (transactionId: string, detail: any) => (
        <a
          href={`/transaction/${transactionId}?stores=${detail?.storeNo}`}
          className='text-primary'
        >
          {intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.DETAIL'})}
        </a>
      ),
    },
  ]

  useEffect(() => {
    if (listFilter?.filterList?.length > 0 || listFilter?.paging?.currentPageNumber > 1) {
      listFilterSet({
        ...listFilter,
        paging: {
          ...paging,
          currentPageNumber: 1,
          pageSize: paging.pageSize,
        },
        filterList: [],
      })
    }
  }, [])

  return (
    <>
      <FilterDrawer setOpen={setOpen} open={open} />

      <div className='card mt-10'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            {disclaimer && (
              <div className=''>
                <h3 className='mb-0'>Transactions</h3>
                <p className='text-muted fs-7'>
                  View a complete list of all transactions made by your members. Use this table to
                  track transaction details such as time, amount, channel, and associated member
                  information.
                </p>
              </div>
            )}
          </div>

          <div className='card-toolbar'>
            <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                <button
                  className='btn btn-light'
                  onClick={() => setOpen(true)}
                  // id='kt_filter_membertrx_button'
                >
                  <i className='bi bi-sliders fs-4 me-4'></i>
                  {intl.formatMessage({id: 'GLOBAL.FILTER'})}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <Table
              loading={isLoading}
              dataSource={list?.dataList}
              columns={Columns}
              pagination={{
                current: paging.currentPageNumber,
                pageSize: paging.pageSize,
                total: paging.totalCount,
                onChange: (page: any) => {
                  if (!list || !list.dataList) return
                  const {pageSize, current} = page
                  const currentPage = pageSize !== list.paging.pageSize ? 1 : current

                  listFilterSet({
                    ...listFilter,
                    paging: {
                      ...paging,
                      currentPageNumber: currentPage,
                      pageSize: pageSize,
                    },
                  })
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default TransactionItemList
